import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from "@ngrx/store";
import { firstValueFrom } from "rxjs";
import { AssignmentModel } from "../../../../models/assignment.model";
import { CustomerModel } from "../../../../models/customer.model";
import { EmployeeModel } from "../../../../models/employee.model";
import { JobPlaceModel } from "../../../../models/jobPlace.model";
import { PaginationModel } from "../../../../models/pagination.model";
import { SkillModel } from "../../../../models/skill.model";
import * as fromApp from "../../../../store/app.reducer";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AssigmentShiftSummaryCalculationComponent } from '../../../../shared/components/assigment-shift-summary-calculation/assigment-shift-summary-calculation.component';
import { CommonModule } from '@angular/common';
import { GuardDetailsModalComponent } from '../../../../shared/components/guard-details-modal/guard-details-modal.component';
import { CommonConstants } from '../../../../constants/common-constant';
import { CalendarDataRefreshService } from '../../../../services/calendar-data-refresh.service';
import { CommonService } from 'src/app/services/common.service';
import { LoadingService } from 'src/app/service/loading-service.service';
const statusMap = {
  1: 'Publish',
  2: 'Ready',
  3: 'Ongoing',
  4: 'Finished',
  5: 'Canceled',
};
@Component({
  imports: [AssigmentShiftSummaryCalculationComponent, TranslateModule, CommonModule],
  selector: 'app-ongoing',
  templateUrl: './ongoing.component.html',
  styleUrls: ['./ongoing.component.scss'],
  standalone: true
})
export class OngoingComponent implements OnInit, OnDestroy {
  public customer: CustomerModel;
  public employee: EmployeeModel;
  public objects: JobPlaceModel[];
  public skills: SkillModel[];
  public assignments: AssignmentModel[];
  public pagination: PaginationModel;
  public dataLoading = false;
  onGoinfShftData: any
  commonConstants = CommonConstants
  private hasDataChanged: boolean = false;
  customerId: any
  subscription: any

  constructor(
    private dialog: MatDialog,
    private store: Store<fromApp.AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OngoingComponent>,
    private calendarDataRefreshService: CalendarDataRefreshService,
    private service: CommonService,
    private loadingService: LoadingService,
    private translate: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.onGoinfShftData = this.data;
    try {
      const authState = await firstValueFrom(this.store.select(state => state.auth));
      this.customerId = authState?.customer?.id;
      if (!this.customerId) {
        console.error("Customer ID not found.");
        return;
      }
      await this.getShiftData();
    } catch (error) {
      console.error("Error initializing component:", error);
    }
    this.subscription = this.store.subscribe(appState => {
      this.customer = appState.auth.customer;
    });
  }

  ngOnDestroy() {
    // This handles ESC, click outside, etc. without duplicate API calls
    if (this.hasDataChanged) {
      this.calendarDataRefreshService.triggerRefresh('shift_updated', this.onGoinfShftData?.id);
    }
  }

  CalculationGuardPerHoursRate(costPerGuard: number, duration: number): number {
    if (!costPerGuard || !duration || duration <= 0) {
      return 0;
    }
    return costPerGuard / duration;
  }

  //Open popup modal for show guard details
  showGuardDetails(guardDetails: any) {
    this.dialog.open(GuardDetailsModalComponent, {
      data: guardDetails
    });
  }

  displayStatus = (status: number | null | undefined) => {
    if (typeof status === 'number') {
      return this.translate.instant(`shift-status.${status}`) || this.translate.instant('shift-status.unknown');
    }
    return this.translate.instant('shift-status.unknown');
  };

  closeModal() {
    this.dialogRef.close({ success: true });
  }

  isSameOrEarlier(startTime: string, checkinDateTime: string): boolean {
    const checkinTime = new Date(checkinDateTime);
    const [startHour, startMinute] = startTime.split(':').map(Number);

    // Create a Date object for startTime (using same date as checkinTime)
    const startDateTime = new Date(checkinTime);
    startDateTime.setHours(startHour, startMinute, 0, 0);

    return startDateTime.getTime() <= checkinTime.getTime();
  }

  isStartAfterCheckin(startTime: string, checkinDateTime: string): boolean {
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const shiftTime = new Date();
    shiftTime.setHours(startHour);
    shiftTime.setMinutes(startMinute);
    shiftTime.setSeconds(0);
    shiftTime.setMilliseconds(0);

    const checkinTime = new Date(checkinDateTime);
    return shiftTime < checkinTime;
  }

  getMinutesLate(startTime: string, checkinDateTime: string): number {
    const [startHour, startMinute] = startTime.split(':').map(Number);

    const shiftTime = new Date();
    shiftTime.setHours(startHour, startMinute, 0, 0);

    const checkinTime = new Date(checkinDateTime);

    if (shiftTime < checkinTime) {
      const diffMs = checkinTime.getTime() - shiftTime.getTime();
      return Math.floor(diffMs / 60000); // difference in minutes
    }
    return;
  }

  private async getShiftData(): Promise<void> {
    this.loadingService.showLoader();
    try {
      const response: any = await firstValueFrom(
        this.service.getShiftDetailsById(this.customerId, this.onGoinfShftData.id)
      );
      this.onGoinfShftData = response.data;
    } catch (error) {
      console.error("Something went wrong while fetching shift data:", error);
    } finally {

      this.loadingService.hideLoader();
    }
  }

}
